<template>
    <div>
        <div class="pb-2">
            <b-row>
                <b-col md="3" class="mt-25">
                    <b-form-group label="وضعیت درخواست" label-for="statusId">
                        <v-select v-model="parameters.status" :searchable="false" dir="rtl" :options="statusData"
                            :reduce="(value) => value.id" label="name" id="statusId" class="bg-white"
                            style="border-radius: 6px;" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="mt-0 mt-md-2">
                    <b-button variant="info" @click="getSmsSchedules" :disabled="loading"
                        class="mt-25 d-flex justify-content-center w-100">
                        <span>جستجو</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
            </b-row>

            <b-card class="p-0 mt-2 mt-md-1" no-body>
                <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                    <b-table v-if="requestList.length" responsive :items="requestList" :fields="fields" class="mb-0"
                        striped>
                        <template #cell(details)="data">
                            <feather-icon @click="showDetails(data.item.id)" size="20" icon="InfoIcon"
                                class="pointer text-info" color="#8d88a3" />
                        </template>
                        <template #cell(status)="data">
                            <b-badge :variant="requestStatusColor(data.item.status)" pill>
                                {{ requestStatus(data.item.status) }}
                            </b-badge>
                        </template>
                        <template #cell(createdAt)="data">
                            <div>
                                <span>
                                    {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                                </span>
                            </div>
                        </template>
                    </b-table>
                    <div v-else class="text-center pt-5 pb-4">
                        موردی وجود ندارد
                    </div>
                </b-overlay>
            </b-card>
            <b-pagination align="center" @input="getSmsSchedules" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>


        <!------------------------------- modal detail ------------------------------->
        <b-modal id="sms-schedules-detail" title="جزئیات" centered :hide-footer="true" title-class="font-weight-bolder"
            size="lg">
            <div>
                <b-row>
                    <b-col md="6" class="mb-1">
                        <h4 class="text-info">عنوان</h4>
                        <h5>{{ smsSchedulesDetails.title }}</h5>
                    </b-col>
                    <b-col md="6" class="mb-1">
                        <h4 class="text-info">وضعیت</h4>
                        <h5>{{ requestStatus(smsSchedulesDetails.status) }}</h5>
                    </b-col>
                    <b-col md="6" class="mb-1">
                        <h4 class="text-info">زمان ثبت درخواست</h4>
                        <h5>
                            <span>
                                {{ new Date(smsSchedulesDetails.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new
                                    Date(smsSchedulesDetails.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                            </span>
                        </h5>
                    </b-col>
                    <b-col md="6" class="mb-1">
                        <h4 class="text-info">زمان ارسال</h4>
                        <h5>
                            <span>
                                {{ new Date(smsSchedulesDetails.dateTime).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new
                                    Date(smsSchedulesDetails.dateTime).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                            </span>
                        </h5>
                    </b-col>
                    <b-col md="6" class="mb-1">
                        <h4 class="text-info">مانده شارژ پنل پیامکی مجموعه</h4>
                        <h5>{{ smsSchedulesDetails.store ?
                            `${smsSchedulesDetails.store.smsChargeBalance.toLocaleString('fa-IR')} ریال` : '-' }}</h5>
                    </b-col>
                    <b-col md="6" class="mb-1">
                        <h4 class="text-info">هزینه کل پیام‌ها</h4>
                        <h5>{{ smsSchedulesDetails.totalMessagesCost ?
                            `${smsSchedulesDetails.totalMessagesCost.toLocaleString('fa-IR')} ریال` : '-' }}
                        </h5>
                    </b-col>
                    <b-col md="6" class="mb-1">
                        <h4 class="text-info">تعداد مشتریان</h4>
                        <h5>{{ smsSchedulesDetails.customersCount }}</h5>
                    </b-col>
                    <b-col md="6" class="mb-1">
                        <h4 class="text-info">تعداد موفق ارسال شده</h4>
                        <h5>{{ smsSchedulesDetails.successfulSentCount ? smsSchedulesDetails.successfulSentCount : '-'
                            }}</h5>
                    </b-col>
                    <b-col md="6" class="mb-1">
                        <h4 class="text-info">میانگین هزینه پیام</h4>
                        <h5>{{ smsSchedulesDetails.averageMessageCost ?
                            `${smsSchedulesDetails.averageMessageCost.toLocaleString('fa-IR')} ریال` : '-' }}
                        </h5>
                    </b-col>
                    <b-col md="6" class="mb-1">
                        <h4 class="text-info">نام مجموعه</h4>
                        <h5>{{ smsSchedulesDetails.store ? smsSchedulesDetails.store.name : '-' }}</h5>
                    </b-col>
                    <b-col md="12" class="mb-2">
                        <b-form-textarea v-model="smsSchedulesDetails.message" disabled dir="rtl"
                            class="text-primary-middle" rows="6" no-resize />
                    </b-col>
                    <b-col md="6" class="mb-1">
                        <b-button variant="danger" @click="requestManagement('false')"
                            :disabled="smsSchedulesDetails.status != 0"
                            class="w-100 d-flex align-items-center justify-content-center">
                            <span>رد</span>
                        </b-button>
                    </b-col>
                    <b-col md="6" class="mb-1">
                        <b-button variant="success" @click="requestManagement('true')"
                            :disabled="smsSchedulesDetails.status != 0"
                            class="w-100 d-flex align-items-center justify-content-center">
                            <span>تایید</span>
                        </b-button>
                    </b-col>
                </b-row>


            </div>
        </b-modal>

        <!-------------------------------------- modal cancel sms -------------------------------------->
        <b-modal id="request-sms" title="درخواست" centered :hide-footer="true" title-class="font-weight-bolder">
            <div class="p-1">
                <h5 class="text-center danger mb-3 mt-1"
                    :class="requestManagementData.approve ? 'text-success' : 'text-danger'">
                    آیا از {{ requestManagementData.mode }} این درخواست مطمئن هستید؟
                </h5>
                <div class="d-flex align-items-center">
                    <b-button @click="$bvModal.hide('request-sms')" class="w-50 mr-1" variant="secondary">
                        انصراف
                    </b-button>
                    <b-button type="submit" :variant="requestManagementData.approve ? 'success' : 'danger'"
                        @click="smsChangeStatus" :disabled="loadingButton"
                        class="w-50 d-flex align-items-center justify-content-center">
                        <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                        <span>{{ requestManagementData.approve ? 'تایید' : 'رد' }}</span>
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>


<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BFormTextarea, BAlert, BTable, BBadge, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BFormFile, BMediaBody, BFormInput, BFormGroup, BSpinner } from 'bootstrap-vue';
import { adminService } from '@core/services';
import vSelect from 'vue-select';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BBadge,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BAlert,
        BFormFile,
        vSelect
    },
    computed: {
        requestStatus() {
            return (status) => {
                if (status == 0) {
                    return 'در حال بررسی'
                }
                if (status == 1) {
                    return 'تایید شده'
                }
                if (status == 2) {
                    return 'رد شده'
                }
                if (status == 3) {
                    return 'لغو شده'
                }
                if (status == 4) {
                    return 'ناموفق'
                }
            }
        },
        requestStatusColor() {
            return (status) => {
                if (status == 0) {
                    return 'light-primary'
                }
                if (status == 1) {
                    return 'light-success'
                }
                if (status == 2) {
                    return 'light-danger'
                }
                if (status == 3) {
                    return 'light-secondary'
                }
                if (status == 4) {
                    return 'light-secondary'
                }
            }
        },
    },
    data() {
        return {
            smsSchedulesDetails: {},
            loadingButton: false,
            loading: false,
            statusData: [
                { name: 'همه', id: null },
                { name: 'در حال بررسی', id: 0 },
                { name: 'تایید شده', id: 1 },
                { name: 'رد شده', id: 2 },
                { name: 'لغو شده', id: 3 },
                { name: 'ناموفق', id: 4 },
            ],
            requestList: [],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                storeId: null,
                status: null,
            },
            fields: [
                {
                    key: 'store.name',
                    label: 'نام مجموعه',
                },
                {
                    key: 'createdAt',
                    label: 'زمان ثبت درخواست',
                },
                {
                    key: 'title',
                    label: 'عنوان درخواست',
                },
                {
                    key: 'status',
                    label: 'وضعیت درخواست',
                },
                {
                    key: 'details',
                    label: 'جزئیات',
                },
            ],
            requestManagementData: {
                mode: '',
                approve: null
            }
        }
    },
    methods: {
        requestManagement(type) {
            if (type == 'true') {
                this.requestManagementData.mode = 'تایید'
                this.requestManagementData.approve = true
            }
            else {
                this.requestManagementData.mode = 'رد'
                this.requestManagementData.approve = false
            }
            this.$bvModal.show('request-sms')
        },
        showDetails(id) {
            adminService.getSmsSchedulesById(id).then(({ data }) => {
                this.smsSchedulesDetails = data
                this.$bvModal.show('sms-schedules-detail')
            })
        },
        smsChangeStatus() {
            this.loadingButton = true;
            adminService.smsChangeStatus({ scheduleId: this.smsSchedulesDetails.id, approve: this.requestManagementData.approve }).then(({ data }) => {
                this.loadingButton = false;
                this.$bvModal.hide('request-sms')
                this.$bvModal.hide('sms-schedules-detail')
                this.getSmsSchedules()
            })
        },
        getSmsSchedules() {
            this.loading = true
            adminService.smsSchedules(this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.requestList = data.items
                this.loading = false
            })
        },
    },
    mounted() {
        this.getSmsSchedules()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>